/**
 * StepItem - Single pill in the document submission roadmap.
 * Shows step label and completion count (X/Y). Appearance depends on state:
 * - pending: grey background, dark grey text
 * - current: light blue background, dark blue text
 * - completed: dark green background, white text
 */
import React from 'react';
import './StepItem.css';

export type StepState = 'pending' | 'current' | 'completed';

export interface StepItemProps {
  /** Step label (e.g. LINE, 各種コピー) - already translated by parent */
  label: string;
  /** Number of items completed in this step */
  completed: number;
  /** Total number of items in this step */
  total: number;
  /** Visual state for styling */
  state: StepState;
  /** Optional red indicator badge count (e.g. resubmission needed). */
  badgeCount?: number;
  /** Optional click handler (e.g. navigate to step) */
  onClick?: () => void;
}

const StepItem: React.FC<StepItemProps> = ({
  label,
  completed,
  total,
  state,
  badgeCount,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`step-item step-item--${state}`}
      onClick={onClick}
      aria-current={state === 'current' ? 'step' : undefined}
    >
      <span className="step-item__label">{label}</span>
      <span className="step-item__count">
        {completed}/{total}
      </span>
      {typeof badgeCount === 'number' && badgeCount > 0 && (
        <span className="step-item__badge" aria-label={`${badgeCount}`}>
          {badgeCount}
        </span>
      )}
    </button>
  );
};

export default StepItem;
